import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { regions } from "../../constants/regions";
import { categories } from "../../constants/categories";

const ChoixForfait = () => {
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);



  // Ajouter ou retirer une région
  const handleRegionChange = (region) => {
    setSelectedRegions((prev) =>
      prev.includes(region)
        ? prev.filter((r) => r !== region)
        : [...prev, region]
    );
  };

  // Ajouter ou retirer une catégorie
  const handleCategoryChange = (category) => {
    setSelectedCategories((prev) =>
      prev.includes(category)
        ? prev.filter((c) => c !== category)
        : [...prev, category]
    );
  };

  // Calculer le prix total en fonction des régions et métiers sélectionnés
  useEffect(() => {
    const numRegions = selectedRegions.length;
    const numCategories = selectedCategories.length;

    const calculatePrice = (regions, categories) => {
      if (regions === 0 || categories === 0) return 0;

      let pricePerRegion = 0;

      if (categories === 1) pricePerRegion = 49;
      else if (categories === 2) pricePerRegion = 98;
      else if (categories === 3) pricePerRegion = 99;
      else if (categories > 3 && categories < 10)
        pricePerRegion = 99 + (categories - 3) * 49;
      else if (categories === 10) pricePerRegion = 299;
      else if (categories > 10 && categories < 15)
        pricePerRegion = 299 + (categories - 10) * 49;
      else if (categories === 15) pricePerRegion = 399;

      return pricePerRegion * regions;
    };

    const total = calculatePrice(numRegions, numCategories);
    setTotalPrice(total);
  }, [selectedRegions, selectedCategories]);

  return (
    <Container className="mt-5">
      <h2 className="text-center mb-4">Personnalisez votre Forfait</h2>
      <p className="text-center">
        Sélectionnez les régions et les catégories de métier que vous souhaitez.
        Le prix s'ajustera automatiquement.
      </p>

      <Row>
        {/* Sélection des régions */}
        <Col md={6}>
          <h4>Choisissez vos régions :</h4>
          <Form>
            {regions.map((region, index) => (
              <Form.Check
                key={index}
                type="checkbox"
                label={region}
                onChange={() => handleRegionChange(region)}
                checked={selectedRegions.includes(region)}
              />
            ))}
          </Form>
        </Col>

        {/* Sélection des catégories */}
        <Col md={6}>
          <h4>Choisissez vos catégories de métier :</h4>
          <Form>
            {categories.map((category, index) => (
              <Form.Check
                key={index}
                type="checkbox"
                label={category}
                onChange={() => handleCategoryChange(category)}
                checked={selectedCategories.includes(category)}
              />
            ))}
          </Form>
        </Col>
      </Row>

      {/* Affichage du prix total */}
      <div className="text-center mt-4">
        <h3>Résumé de votre sélection :</h3>
        <p>
          <strong>Nombre de régions :</strong> {selectedRegions.length}
        </p>
        <p>
          <strong>Nombre de catégories :</strong> {selectedCategories.length}
        </p>
        <h4 style={{ color: "#ff8c00" }}>
          Prix total : <strong>{totalPrice}€ / an</strong>
        </h4>
      </div>

      {/* Bouton de validation */}
      <div className="text-center mt-4">
        <Button variant="primary" size="lg">
          Valider mon Forfait
        </Button>
      </div>
    </Container>
  );
};

export default ChoixForfait;
